let elementsWithFlip = [];
let elementsWithHoverEffect = [];
document.addEventListener('DOMContentLoaded', function() {
  const elementsWithFlipAttribute = document.querySelectorAll('[flip]');
  const elementsWithFlipBlockAttribute = document.querySelectorAll('[flip-block]');
  console.log(elementsWithFlipAttribute);

  elementsWithFlipAttribute.forEach(element => {
    if (element.getAttribute('flip')) {
            elementsWithFlip.push(element);
        }
  });
  elementsWithFlipBlockAttribute.forEach(element => {
    if(element.getAttribute('flip-block')){
            elementsWithHoverEffect.push(element);
        }
  });
  for (let i = 0; i < 2; i++) {
    console.log(elementsWithFlip[i]);
    elementsWithHoverEffect[i].addEventListener('mouseenter', function() {
      if(i == 0)
      {
        elementsWithFlip[1].firstElementChild.classList.add("flip-it");
      }
      else{
        elementsWithFlip[0].firstElementChild.classList.add("flip-it");
      }
    });
    elementsWithHoverEffect[i].addEventListener('mouseleave', function() {
      if(i == 0)
      {
        elementsWithFlip[1].firstElementChild.classList.remove("flip-it");
      }
      else{
        elementsWithFlip[0].firstElementChild.classList.remove("flip-it");
      }
    });
  }
});